<template>
    <div class="d-company-ratings__tabs">
      <div
        v-for="tab in tabs"
        :key="tab.value"
        :class="['d-company-ratings__tab', { 'active': activeTab === tab.value }]"
        @click="$emit('update:activeTab', tab.value)"
      >
        {{ tab.name }}
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DTabsRatings',
    props: {
      tabs: {
        type: Array,
        required: true
      },
      activeTab: {
        type: [String, Number],
        required: true
      }
    }
  }
  </script>
  
  <style scoped>
  </style>